if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const isProductRetainer = document.querySelector('.single-product-main--retainer');
        const isProductFreeScan = document.querySelector('.single-product-main--free-scan');

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        if (isProductRetainer) {
          const fields = [
            {
              id: 'select-your-dentist',
              type: 'select',
              format: null,
              errors: {
                empty: '<li>Please select a dentist.</li>',
                format: null,
              },
            },
            {
              id: 'patient-name',
              type: 'text',
              format: null,
              errors: {
                empty: '<li>Please fill in your name.</li>',
                format: null,
              },
            },
            {
              id: 'date-of-birth',
              type: 'text',
              format: /^(0+[1-9]|[12]\d|3[01])[\/](0+[1-9]|1[0-2])[\/](19|20)\d{2}$/,
              errors: {
                empty: '<li>Please fill in your <abbr title="Date of Birth">D.O.B.<abbr></li>',
                format: '<li>Invalid format: DD/MM/YYYY.</li>',
              },
            },
            {
              id: 'legal',
              type: 'radio',
              format: null,
              errors: {
                empty: '<li>Please select an option.</li>',
                format: null,
              },
            },
          ];

          if (!this.validateCustomFields(fields)) {
            return;
          }
        }

        if (isProductFreeScan) {
          const fields = [
            {
              id: 'location',
              type: 'select',
              format: null,
              errors: {
                empty: '<li>Please select a location.</li>',
                format: null,
              },
            },
            {
              id: 'patient-name',
              type: 'text',
              format: null,
              errors: {
                empty: '<li>Please fill in your name.</li>',
                format: null,
              },
            },
            {
              id: 'practice',
              type: 'text',
              format: null,
              errors: {
                empty: '<li>Please fill in your practice.</li>',
                format: null,
              },
            },
          ];

          if (!this.validateCustomFields(fields)) {
            return;
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      validateCustomFields(fields) {
        let isValid = true;

        fields.forEach((field) => {
          const errorsEl = document.querySelector(`[data-errors-for="${field.id}"]`);
          const errors = [];

          errorsEl.innerHTML = '';

          if (field.type == 'radio') {
            const els = document.querySelectorAll(`input[id^="${field.id}"]`);

            if (els) {
              if (!Array.from(els).some((el) => el.checked)) {
                isValid = false;
                errors.push(field.errors.empty);
              }

              errorsEl.innerHTML = errors.join('');
            }
          } else {
            const el = document.getElementById(field.id);

            if (el) {
              if (el.value == '' && field.errors.empty != null) {
                isValid = false;
                errors.push(field.errors.empty);
              }

              if (field.format != null && !field.format.test(el.value) && field.errors.format != null) {
                isValid = false;
                errors.push(field.errors.format);
              }

              errorsEl.innerHTML = errors.join('');
            }
          }
        });

        return isValid;
      }
    }
  );
}
